module.exports = ".global-menu {\n  position: fixed;\n  bottom: 20px;\n  right: 20px; }\n"